"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    dataInsight: {
        title: 'Data Insights',
        subTitle: 'Key metrics, student performance, standard comparisons, and assessment details ',
        ariaLabel: {
            collapseButton: 'expand data insights',
        },
        studentName: 'Student Name',
        score: 'Score',
        belowPerformingStudents: {
            title: 'Students performed below the Class Average',
            allAreAveragePerforming: 'All of the students are performing equally',
            performingBelowClassAverageStudent: ' is performing below the class average',
            performingBelowClassAverageStudents: ' are performing below the class average',
            performingBelowClassAverageStudentEquip: ' is performing below the core item’s class average',
            performingBelowClassAverageStudentsEquip: ' are performing below the core item’s class average',
            students: 'students',
            student: 'student',
        },
        standard: {
            highestPerformedStandard: 'The highest performing standard on this assessment is ',
            highestPerformedStandards: 'The highest performing standards on this assessment are ',
            lowestPerformedStandard: 'The lowest performing standard on this assessment is ',
            lowestPerformedStandards: 'The lowest performing standards on this assessment are ',
            belowClassAverageStandardsCount: '{{count}} standards',
            belowClassAverageStandardCount: '{{count}} standard',
            belowClassAverageStandardsCountMessage: 'are performing below the standard’s class average',
            belowClassAverageStandardCountMessage: 'is performing below the standard’s class average',
            equallyScored: 'All of the standards are performing equally.',
            noStandardsExist: 'No standard exist for the selected assessment',
            noStandardsEquip: 'Standards are not applicable on Equip assessments',
            standardsModalTitle: 'Standards performed below the Class Average',
        },
        assessmentTemplates: {
            skipQuestion: '{{percentage}}%  of Students Skipped Item {{question}}',
            highestPerformedItems: 'The highest performing items on this assessment are ',
            highestPerformedItem: 'The highest performing item on this assessment is ',
            lowestPerformedItem: 'The lowest performing item on this assessment is ',
            lowestPerformedItems: 'The lowest performing items on this assessment are ',
            equalPerformance: 'All of the items are performing equally.',
            question: 'Q',
            noItemsExist: 'No items exist for the selected assessment',
            studentName: 'Student name',
            noOfAssessments: 'No. of assignment',
            noOfReopened: 'No. of reopen',
            performedAssessment: {
                assessments: 'assessments in class {{className}}',
                assessment: 'assessment in class {{className}}',
                lowestPerformedAssessment: 'This assessment is the lowest performing assessment in class {{className}}',
                lowestPerformedAssessments: 'This assessment is the lowest performing assessment along with {{assessmentCount}} other ',
                highestPerformedAssessment: 'This assessment is the highest performing assessment in class {{className}}',
                highestPerformedAssessments: 'This assessment is the highest performing assessment along with {{assessmentCount}} other ',
            },
            unAssigned: {
                studentsModalTitle: 'Students who were not assigned the assessment',
                assignedToAllStudents: 'This assessment has been assigned to all the students in class {{className}}',
                notAssignedToNStudentsPart1: 'This assessment was not assigned to ',
                student: '{{studentCount}} student',
                students: '{{studentCount}} students',
                notAssignedToNStudentsPart2: ' from class {{className}}',
            },
            reOpened: {
                modalTitle: 'List of assessment reopened Students',
                reOpenedAssessmentsPart1: 'This assessment was reopened for ',
                reOpenedAssessmentsPart2: ' from all assigned students',
                student: '{{studentCount}} student',
                students: '{{studentCount}} students',
            },
        },
        studentTemplates: {
            studentsMaxScoreModalTitle: 'Students with Max score',
            studentsMinScoreModalTitle: 'Students with Min score',
            maxScore: ' got a max score for this assessment',
            minScore: ' got a min score for this assessment',
            students: '{{students}} students',
            student: '{{students}} student',
            proficiency: 'Distribution of students as per proficiency:',
            highlyProficientStudent: '{{student}} student scored as Highly Proficient',
            highlyProficientStudents: '{{student}} students scored as Highly Proficient',
            proficientStudent: '{{student}} student scored as Proficient',
            proficientStudents: '{{student}} students scored as Proficient',
            partialStudent: '{{student}} student scored as Partially Proficient',
            partialStudents: '{{student}} students scored as Partially Proficient',
            notYetStudent: '{{student}} student scored as Not Yet Proficient',
            notYetStudents: '{{student}} students scored as Not Yet Proficient',
            highestSkippedQuestions: '{{skipPercentage}}% of students skipped items ',
            highestSkippedQuestion: '{{skipPercentage}}% of students skipped item ',
        },
        ariaLabels: {
            headers: '{{tab}} data insights',
        },
    },
};
